import * as z from "zod/v4";

const timeSeriesMetric = z.array(
  z.object({ plainDate: z.string(), value: z.number().optional() }),
);

export const getCheckoutOptimizationTimeSeriesMetrics = {
  name: "getCheckoutOptimizationTimeSeriesMetrics" as const,
  input: z.null(),
  output: z.object({
    checkoutConversionRateOverTimeSeries: timeSeriesMetric,
    averageShippingRevenuePerOrderOverTimeSeries: timeSeriesMetric,
    currency: z.string(),
  }),
};
